import { AxiosResponse } from 'axios'
import { ethers } from 'ethers'
import { blockchainApiClient } from '../httpClient'
import { BlockchainIdentity } from './models/blockchain-identity'
import { ValidateSubscriberRequest } from './models/network-communication'
import { SubmitPaymentResponse } from './models/payment'

export const getPaymentFeeSchedule = async () => {
    const payloads = [
        {
            endpoint: 'ADMIN_PAYOUT',
        },
        {
            endpoint: 'PAYOR_PAYOUT',
        },
        {
            endpoint: 'OTHER_PAYOUT',
        },
    ]
    const responses = (
        await Promise.all(
            payloads.map((payload) =>
                blockchainApiClient.get<any, any>(`/api/v1/chain/reward/api/${payload.endpoint}`),
            ),
        )
    ).map((response) => parseFloat(ethers.utils.formatEther(response.data.output)))

    return {
        adminPayout: responses[0],
        payerPayout: responses[1],
        otherPayout: responses[2],
        total: responses.reduce((acc, val) => acc + val, 0),
    }
}

export const submitRewardPayment = (claimNumber: string) =>
    blockchainApiClient.post<any, AxiosResponse<SubmitPaymentResponse>>(
        '/api/v1/chain/reward/submit-payment',
        { claimNumber },
    )

export const withdrawRewardPayment = (paymentId: string) =>
    blockchainApiClient.post('/api/v1/chain/reward/withdraw-payment', { paymentId })

export const getBlockchainIdentities = async (type: 'payer' | 'provider') =>
    await blockchainApiClient.get<any, AxiosResponse<BlockchainIdentity[]>>(
        `/api/v1/chain/identities/${type}s`,
    )

export const getSelfBlockchainIdentity = () =>
    blockchainApiClient.get<any, AxiosResponse<BlockchainIdentity>>('/api/v1/chain/identities/self')

export const validateSubscriberForNode = (
    payload: ValidateSubscriberRequest['payload'],
    nodeDid: string,
) =>
    blockchainApiClient.post<any, any>('/api/v1/chain/identities/cross-net/validate-subscriber', {
        payload,
        targetNode: nodeDid,
    })

export const getEscrowContracts = ({
    active,
    payerDid,
    providerDid,
    year,
    includeFunds,
}: {
    active?: boolean
    payerDid?: string
    providerDid?: string
    year?: number
    includeFunds?: boolean
}) =>
    blockchainApiClient.get<any, any>(`/api/v1/chain/escrow/search`, {
        params: {
            active,
            payerDid,
            providerDid,
            year,
            includeFunds,
        },
    })
